/**
 * Find the "primary" listing in given cart.
 * Used to dislay recommendations or supportive content
 * Uses the product listing for first sub product available
 * Fallback to first product in cart or `cart.listing`
 *
 * @param {Object} cart - cart object
 * @return {Object} listing - consisting of { listingId, listingVersionId, slug }
 */
export default function findCartPrimaryListing(cart) {
	if (!(cart?.products?.length > 0)) return;

	let hotProduct = findPrimaryCartProduct(cart);
	if (!hotProduct) return;

	// Use product listing if available
	if (hotProduct.listing?.listingId) {
		return { ...hotProduct.listing };
	}

	// Fallback to the cart.listing
	return {
		...cart.listing,
		listingVersionId: cart.listing?.id,
	};
}

/**
 * Find the "primary" product in given cart.
 * Used internally (above) and for Braze tracking
 * ... (its a work-around until we fully support multi-seller purchases (FW-60))
 * Uses the first sub product available
 * Fallback to first product in cart
 *
 * @param {Object} cart - cart object
 * @return {Object} product - cartProduct object
 */
export function findPrimaryCartProduct(cart) {
	if (!(cart?.products?.length > 0)) return;

	// Start with first product in cart
	let hotProduct = cart.products[0];

	// Use first sub product, if available (fallback to first product)
	if (cart.products.length > 1 && !cart.products[0].subscriptionTypeTermId) {
		let firstSubProduct = cart.products.find(p => p.subscriptionTypeTermId > 0);
		if (firstSubProduct) {
			hotProduct = firstSubProduct;
		}
	}

	return hotProduct;
}
